import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const AssetModalWrapper = styled(Modal)`
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
  .ant-modal-body{
    padding: 0;
  }
  .form-title{
    padding: 16px 24px;
    border-bottom: 1px solid #eaeef1;
    h3{
      font-size: 1rem;
    }
  }
  .ant-table-cell-fix-right-first{
    right: -1px !important;
  }
  .ant-table-row-expand-icon{
    &:hover, &:active{
      border-color: #0b2a1b !important;
      color: #fff !important;
      background-color: #0b2a1b !important;
    }
  }
  .form-body{
    padding: 12px 24px 12px 24px;
    .checkbox-contact{
      margin-bottom: 10px;
    }
  }
  .form-modal-content{
    padding: 20px 24px 8px 24px;
  }
  .selected-form-row > td{
    background: #f6ffed !important;
  }
  .ant-pagination-item-active{
    background: #fff;
    border-color: #0b2a1b;
    a{
      color: #0b2a1b;
    }
  }
  .form-filter .ant-input-affix-wrapper .ant-input{
    border: none !important;
    box-shadow: none !important;
  }
  a,.ant-upload .ant-btn:hover,.ant-upload .ant-btn:focus{
    border-color: #0B2A1B;
    color:#0B2A1B
  }
  &.mob-cannot-create .ant-btn-primary{
    display: none;
  }
  .btn-create-breed{
    background-color: #46AFCA;
    border-color: #46AFCA;
    &:hover{
      opacity: 0.8;
    }
    margin-top:30px;
    width: 100%;
    padding: 0;
  }
  .card_content{
    display:inline;
  }

  .card_value{
    float:right;
  }

  .btn-add-outside-trainee{
    &:hover, &:focus{
      border-color: #0b2a1b !important;
      color: #0b2a1b !important;
    }
  }

  .primary-objects-tooltip{
    background: transparent;
    color: white;
    border: none;
    box-shadow: none;
  }

  .ant-picker-dropdown{
    .ant-picker-footer{
      a{
        color: #0b2a1b !important;
      }
      button{
        background-color: #0b2a1b !important;
        color: white !important;
      }
    }
  }
`;

export default WithDirection(AssetModalWrapper);
